module.exports = __webpack_public_path__ + "static/img/5.3c3d1e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/5.png
// module id = JfcM
// module chunks = 0